import { render, staticRenderFns } from "./update.vue?vue&type=template&id=c5a8b3b8&scoped=true&"
import script from "./update.vue?vue&type=script&lang=ts&"
export * from "./update.vue?vue&type=script&lang=ts&"
import style0 from "./update.vue?vue&type=style&index=0&id=c5a8b3b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a8b3b8",
  null
  
)

export default component.exports